export default __webpack_public_path__ + "static/media/BCA4.aff6210d.jpg";